<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('valor-km') }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li><a class="a-inativo">{{ $t('despesas') }}</a></li>
                                <li><a @click="$router.push({ name: 'des-valor-km-list' })">{{ $t('valor-km') }}</a>
                                </li>
                                <li><a aria-current="page">{{ $t('novo') }}</a></li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" tag="button"
                            @click="$router.push({ name: 'des-valor-km' })">
                            {{ $t('voltar') }}
                        </button>
                        <button v-if="(permissao.create) || (permissao.update)" class="save-btn" type="button"
                            @click="saveValorKm" :disabled="isSaving">
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br>
                <div>
                    <div class="columns">
                        <div class="column is-5">
                            <v-money :id="generateId(1)" ref="valorInput" v-model="valorkm.valor" :value="valorkm.valor"
                                :title="'valor'" placeholder="placeholder-preencha" :msg="'msg-campo-obrigatorio'"
                                :invalid="valorkm.valor == 0 ? true : false"></v-money>
                        </div>
                        <div class="column is-5">
                            <vss-select :id="generateId(2)" ref="tipoVeiculoSelect" title="tipo-veiculo"
                                placeholder="selecione" :options="tipoVeiculos" v-model="tipoVeiculo"
                                msg="msg-campo-obrigatorio" :invalid="tipoVeiculo == null ? true : false" />
                        </div>
                        <div class="column is-5">
                            <div>
                                <label>{{ $t('acerto-padrao-pergunta') }}</label>
                                <b-icon 
                                    icon="information" 
                                    size="is-small" 
                                    v-tippy 
                                    :title="$t('info-acerto-padrao')"
                                />
                            </div>
                            <b-switch 
                                :id="generateId(3)" 
                                v-model="acertoPadrao"
                                :title="acertoPadrao ? $t('ativado') : $t('desativado')"
                                :disabled="acertoPadraoDisabled"
                            >
                                <span v-if="acertoPadrao">{{ $t('desativar') }}</span>
                                <span v-else>{{ $t('ativar') }}</span>
                            </b-switch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ValoresKmService from "@/services/despesas/ValoresKmService";
import TipoVeiculoService from "@/services/despesas/TipoVeiculoService";
import ValoresKmValidation from "@/services/validations/despesas/ValoresKmValidation";
import Message from "@/models/Message";

export default {
    data() {
        return {
            acertoPadrao: false,
            acertoPadraoDisabled: false,
            service: new ValoresKmService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: null,
            valorkm: {
                valor: 0
            },
            tipoVeiculos: [],
            tipoVeiculo: null,
            tipoVeiculoService: new TipoVeiculoService(this.$http, this.$router),
            data: {},
            primeiro: false,
            isMobile: false
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess("despesas", "cadastros", "des-valor-km");
        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'valor-km' }
            });
        } else {
            this.validation = new ValoresKmValidation(this.msgs);
            this.findAllTipoVeiculo();
        }
        this.getPrimeiro();
    },
    mounted() {
        this.resize();
    },
    watch: {
        tipoVeiculo: {
            deep: true,
            handler: function () {
                this.acertoPadraoFind(false);
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        getPrimeiro() {
            this.service.getPrimeiro()
                .then(res => {
                    this.primeiro = !res.content;

                    if (!res.content) {
                        this.acertoPadrao = true;
                        this.acertoPadraoDisabled = true;
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.msgs.push(
                        new Message("error", 'msg-erro-load', true)
                    );
                    return false;
                });
        },
        acertoPadraoFind(save) {
            this.isLoading = true;
            this.service.validacaoDeAcertoPadrao(this.tipoVeiculo.id)
                .then(res => {
                    if (res.content != null) {
                        this.acertoPadrao = true;
                        this.acertoPadraoDisabled = true;
                    } else if (!save && !this.primeiro) {
                        this.acertoPadrao = false;
                        this.acertoPadraoDisabled = false;
                    }
                    if (save) {
                        if (!this.acertoPadraoDisabled && this.acertoPadrao) {
                            this.prompt();
                        } else {
                            this.save();
                        }
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.msgs.push(
                        new Message("error", 'msg-erro-load', true)
                    );
                    return false;
                })
                .finally(_ => {
                    this.isLoading = false;
                })
        },
        findAllTipoVeiculo() {
            this.tipoVeiculoService.findAllCombo("")
                .then(this.mapItemsTipoVeiculo)
                .then(res => {
                    this.tipoVeiculos = res;
                })
                .catch(e => {
                    console.error(e);
                });
        },
        mapItemsTipoVeiculo(body) {
            let list = body.content.map(m => {
                return {
                    id: m.idtipoveiculo,
                    label: m.descricao,
                    cor: m.cor,
                    icone: m.icone.toLowerCase(),
                };
            });
            return list;
        },
        saveValorKm() {
            this.isLoading = true;
            this.data = {
                valor: this.valorkm.valor,
                idtipoveiculo: this.tipoVeiculo != null ? this.tipoVeiculo.id : null,
                acertoPadrao: this.acertoPadrao ? 1 : 0
            }

            if (this.validation.validate(this.data, this.$refs)) {
                this.acertoPadraoFind(true);
            } else {
                this.isLoading = false;
            }
        },
        prompt() {
            this.$root.confirm({
                message: this.$t("msg-alterar-acerto-padrao"),
                onConfirm: this.save,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.isLoading = false;
        },
        save() {
            if (this.validation.validate(this.data, this.$refs)) {
                this.isSaving = true;

                this.service.save(this.data)
                    .then(value => {
                        if (value.status == 200) {
                            let msg = 'msg-save-valor-km'
                            this.msgs.push(new Message("success", msg, true));
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message("alert", value.message, true))
                            } else {
                                this.msgs.push(
                                    new Message("error", "msg-problema-realizar-acao", true)
                                );
                            }
                        }
                    })
                    .catch(e => {
                        console.error(e)
                        this.msgs.push(
                            new Message("error", 'msg-erro-load', true)
                        );
                    })
                    .finally(() => {
                        this.isSaving = false
                        this.isLoading = false
                        this.redirectToList()
                    });

            } else {
                this.isLoading = false;
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: "des-valor-km",
                });
            }, 1000);
        },
        resize() {
            this.isMobile = window.innerWidth <= 768;
        }
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
    }
}
</style>
